import React, { useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import './ParentHeader.css';
import ProfileAvatar from './ProfileAvatar';
import { fetchChildProfile } from '../api/studentApi';
import { useUser } from '../context/UserContext';

const ParentHeader = ({ studentId }) => {
  const { user, logoutUser } = useUser();
  const [student, setStudent] = useState(null);


  useEffect(() => {
    const getChildProfile = async () => {
      try {
        const response = await fetchChildProfile(studentId);
        setStudent(response.data);
      } catch (error) {
        console.error("Failed to load child profile:", error);
      }
    };

    if (studentId) {
      getChildProfile();
    }
  }, [studentId]); // Re-run when studentId changes

  const onLogout = () => {
    logoutUser();
    window.location.href = "/login";
  };

  return (
    <header className="parent-header">
      <div className="header-left">
        <ProfileAvatar />
        <div className="greeting-text">
          <div className="greeting-row">
            <h2 className="greeting">{user?.username?.split('.')[0] || 'Explorer'}</h2>
          </div>
          <span className="child-name">{student?.username ? `Progress for ${student.username}` : 'Welcome back!'}</span>
        </div>
      </div>

      <div className="header-right">
        <button className="logout-btn" onClick={onLogout} title="Logout">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default ParentHeader;